import React, { useEffect } from 'react';
import { Col, Modal, Row } from 'antd';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
//
import { requestCarSchema } from './request-car.schema';
import { BasicFormWrapper } from '../../styled';
import { CAR_AMIGO_FUELS, CAR_AMIGO_GEARBOX } from '../../../utils/caramigo';
import { getAllBrands } from '../../../redux/carbrand/actionCreator';
import { Button } from '../../../components/buttons/buttons';
import FormInput from '../../../components/input/input';
import { contentAccordingToLang } from '../../../utils/common';
import FormSelect from '../../../components/select/FormSelect';

const RequestCar = ({ visible, onCancel, handleSubmit }) => {
  const dispatch = useDispatch();
  const { brands } = useSelector(state => {
    return {
      brands: state.carBrand.brands,
    };
  });

  useEffect(() => {
    if (!brands || brands.length === 0) {
      dispatch(getAllBrands('?all=true'));
    }
  }, []);

  return (
    <Modal type="primary" title="Request Car" footer={null} onCancel={onCancel} visible={visible}>
      <div className="brand-modal">
        <Formik
          validationSchema={requestCarSchema}
          initialValues={{
            brand: null,
            model: null,
            fuel: null,
            gearbox: null,
            year: null,
            numberAsked: null,
            powerfrom: null,
            powerto: null,
            powertype: null,
            kmfrom: null,
            kmto: null,
            all_validation: null, // Dummy field to store validation error
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            handleSubmit(values, resetForm);
          }}
        >
          {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => {
            return (
              <Form>
                <BasicFormWrapper>
                  <div className="add-product-block">
                    {errors.all_validation ? (
                      <Row style={{ marginBottom: '16px' }}>
                        <span style={{ color: '#ff4d4f', fontSize: '14px' }}>{errors.all_validation}</span>
                      </Row>
                    ) : (
                      <></>
                    )}
                    <Row gutter={[12, 12]}>
                      <Col xs={24}>
                        <FormInput
                          type="text"
                          name="year"
                          label="Year"
                          handleChange={handleChange}
                          errors={errors}
                          touched={touched}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormInput
                          type="text"
                          name="brand"
                          label="Brand"
                          value={values.brand}
                          handleChange={handleChange}
                          errors={errors}
                          touched={touched}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormInput
                          type="text"
                          name="model"
                          label="Model"
                          value={values.model}
                          handleChange={handleChange}
                          errors={errors}
                          touched={touched}
                          style={{ marginTop: '16px' }}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormSelect
                          name="fuel"
                          label="Fuel Type"
                          value={values.fuel}
                          options={CAR_AMIGO_FUELS.map(fuel => ({
                            value: fuel.id,
                            key: fuel.id,
                            label: contentAccordingToLang(fuel.details).fuel_name,
                          }))}
                          handleChange={value => setFieldValue('fuel', value)}
                          placeholder="Select Fuel Type"
                          errors={errors}
                          touched={touched}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormSelect
                          name="gearbox"
                          label="Gearbox"
                          value={values.gearbox}
                          options={CAR_AMIGO_GEARBOX.map(fuel => ({
                            value: fuel.id,
                            key: fuel.id,
                            label: contentAccordingToLang(fuel.details).name,
                          }))}
                          handleChange={value => setFieldValue('gearbox', value)}
                          placeholder="Select Fuel Type"
                          errors={errors}
                          touched={touched}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormInput
                          type="number"
                          name="numberAsked"
                          label="No of Vehicle"
                          value={values.numberAsked}
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormInput
                          type="number"
                          name="powerfrom"
                          label="Power From"
                          value={values.powerfrom}
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormInput
                          type="number"
                          name="powerto"
                          label="Power To"
                          value={values.powerto}
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormInput
                          type="number"
                          name="pwoertype"
                          label="Power Type"
                          value={values.powertype}
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormInput
                          type="number"
                          name="kmfrom"
                          label="Km From"
                          value={values.kmfrom}
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                        />
                      </Col>
                      <Col xs={12}>
                        <FormInput
                          type="number"
                          name="Kmto"
                          label="Km To"
                          value={values.kmto}
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                        />
                      </Col>
                    </Row>
                    <div style={{ height: '16px' }} />
                    <Col xs={24}>
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          style={{
                            backgroundColor: '#155BDC',
                            color: '#fff',
                            marginRight: 5,
                            height: '40px',
                            fontWeight: '500',
                          }}
                          htmlType="submit"
                        >
                          Request Car
                        </Button>
                        <Button
                          size="default"
                          type="white"
                          style={{
                            marginRight: 5,
                            height: '40px',
                            fontWeight: '500',
                          }}
                          key="back"
                          outlined="true"
                          onClick={() => {
                            resetForm();
                            onCancel();
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Col>
                  </div>
                </BasicFormWrapper>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
};

export default RequestCar;
